import { authToken } from './internal';
export const getFile = (path, options = {}) => fetch(`${path}`, Object.assign(Object.assign({}, options), { headers: authToken != ''
        ? {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
            'X-Debbie-Auth-Token': authToken,
        }
        : {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': 'application/json',
        } }))
    .then((res) => res.blob())
    .then((blob) => {
    const file = URL.createObjectURL(blob);
    return file;
});
export const downloadFile = (path, fileName, options = {}) => getFile(path, options).then((file) => {
    const link = document.createElement('a');
    link.download = fileName;
    link.href = file;
    link.style.display = 'hidden';
    document.body.appendChild(link);
    link.click();
    link.remove();
});
//# sourceMappingURL=files.js.map